import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-1LNG5RTKF7';

let gaEnabled = false;

/** Initialize GA4 once. No-ops if REACT_APP_GA_MEASUREMENT_ID is unset. */
export function initGA(): void {
  if (!GA_MEASUREMENT_ID) {
    return;
  }
  try {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    gaEnabled = true;
  } catch {
    gaEnabled = false;
  }
}

function isGaActive(): boolean {
  return gaEnabled && Boolean(GA_MEASUREMENT_ID);
}

/** SPA page view (protected app routes typically call this from DashboardLayout). */
export function trackPageView(path: string, title?: string): void {
  if (!isGaActive()) return;
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    ...(title ? { title } : {}),
  });
}

/** GA4 recommended or custom events. */
export function trackEvent(action: string, params: Record<string, unknown> = {}): void {
  if (!isGaActive()) return;
  ReactGA.event(action, params);
}

/** Bind signed-in user for cross-session reporting (use stable id — email from your User model). */
export function setUserId(userId: string | null | undefined): void {
  if (!isGaActive() || !userId) return;
  ReactGA.set({ userId });
}

/** Clear user id on logout. */
export function clearUserId(): void {
  if (!isGaActive()) return;
  ReactGA.gtag('set', { user_id: '' });
}
